import React from "react";
import "./PhoneAnimation.css";

const OVERLAY_SRC: string = "./bento-images/overlay-phone.png";
const INNERLAY_SRC: string = "./bento-images/innerlay-phone.jpg";

export default function PhoneAnimation(): React.ReactElement {
    return (
        <div className="phone-animation">
            <img
                className="phone-animation-innerlay"
                src={INNERLAY_SRC}
                alt="App dashboard screenshot"
            />
            <img
                className="phone-animation-overlay"
                src={OVERLAY_SRC}
                alt="Phone frame"
            />
        </div>
    );
}
